
import type { IConfigurationEntity, SettingValueType, } from "../../../interfaces";
import { BooleanInput } from "./BooleanInput/BooleanInput";
import { NumberInput } from "./NumberInput/NumberInput";
import { StringInput } from "./StringInput/StringInput";
import { UrlInput } from "./UrlInput/UrlInput";

export interface IValueInputProps {
    entity: IConfigurationEntity;
    value: SettingValueType;
    label: string;
    onIsValidChange(isValid: boolean): void;
    onValueChange(value: SettingValueType): void;
}

export const ValueInput = (props: IValueInputProps) => {
    const { entity, value, label, onIsValidChange, onValueChange } = props;

    const onValueChanged = (newValue: SettingValueType) => {
        onValueChange(newValue);
    };

    const onIsValidChanged = (isValid: boolean): void => {
        onIsValidChange(isValid);
    };

    const renderInputControl = () => {
        switch (entity?.type) {
            case "boolean":
                return (<BooleanInput
                    value={Boolean(value)}
                    label={label}
                    onValueChange={onValueChanged} />);

            case "URL":
                return (<UrlInput
                    value={String(value)}
                    label={label}
                    onValueChange={onValueChanged}
                    onIsValidChange={onIsValidChanged} />);

            case "number":
                return (<NumberInput
                    settingKey={entity.key}
                    value={Number(value)}
                    label={label}
                    onValueChange={onValueChanged}
                    onIsValidChange={onIsValidChanged } />);

            default:
                return (<StringInput
                    value={String(value)}
                    label={label}
                    onValueChange={onValueChanged}
                    onIsValidChange={onIsValidChanged} />);
        }
    };

    return (
        <>
            {renderInputControl()}
        </>
    );
};